export class ProjectByTeamLeadView  {
  id: number;
  name: string;
  hasBeenChosen: boolean = true;

}